import { signIn, useSession } from "next-auth/react"
import posthog from "posthog-js";
import { useEffect, useState } from "react";

export default function RequiresAuthentication<T extends object>(WrappedComponent: React.ComponentType<T>)  {
  return (props: T) => {
    const [authenticated, setAuthenticated] = useState(false);
    const { data: session, status } = useSession({
      required: true,
      onUnauthenticated() {
        signIn();
      }
    })

    useEffect(() => {
      if (status === "authenticated" || status === "unauthenticated") {
        setAuthenticated(status === "authenticated");
      }
    }, [status]);

    return authenticated ? (
      <WrappedComponent {...props} />
    ) : (
      <div className="flex min-h-dvh flex-col items-center justify-center">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div>Loading...</div>
        </div>
    );
  };
}